<p-toast position="top-center" key="tc" />

@if (loading) {
  <div class="me-3 mt-3">
    <div class="d-flex align-items-center">
      <strong>Caricamento...</strong>
      <p-progress-spinner class="ms-auto" aria-label="Caricamento" [style]="{ width: '5rem', height: '5rem' }" />
    </div>
  </div>
} @else {
  <p-table [value]="teams"
    [paginator]="true"
    [rows]="25"
    [globalFilterFields]="['teamId', 'name']"
    stripedRows
    #dt>
    <ng-template #caption>
      <div class="flex items-center justify-between">
        <span class="text-xl font-bold">Elenco squadre</span>
        <div class=" inline-flex gap-2">
          <div class="flex">
            <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')" placeholder="Cerca..." />
          </div>
          <p-button icon="fas fa-plus" rounded raised (click)="onShowDialog(newItem)"
            pTooltip="Aggiungi squadra" tooltipPosition="bottom" />
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th style="width:10%">ID</th>
          <th style="width:20%">Organizzazione</th>
          <th>Nome Squadra</th>
          <th style="width:10%"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-team>
        <tr [pSelectableRow]="team">
          <td>{{ team.teamId }}</td>
          <td>{{ team.organization }}</td>
          <td>{{ team.name }}</td>
          <td>
            <p-button icon="fas fa-file-pen" (click)="onShowDialog(team)" />
          </td>
        </tr>
      </ng-template>
    </p-table>
  }


  <p-dialog header="Header"
    [(visible)]="showDialog"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    [resizable]="false">
    <ng-template pTemplate="header">
      <div class="grid w-full grid-cols-3 items-center gap-3 p-4">
        <label for="teamId" class="text-left font-semibold">ID</label>
        <input pInputText id="teamId" class="orgdept-input col-span-2" [disabled]="true" [(ngModel)]="selectedItem.teamId" />

        <label for="name" class="text-left font-semibold">Name</label>
        <input pInputText id="name" class="orgdept-input col-span-2" [disabled]="!isNew" [(ngModel)]="selectedItem.name" />
      </div>
    </ng-template>

    <div class="grid w-full grid-cols-3 items-center gap-3 px-4">
      <label for="organization" class="text-left font-semibold">Organizzazione</label>
      <p-select id="organization" [options]="organizationOptions" optionLabel="value" [(ngModel)]="selectedOrganization" class="col-span-2 text-left" appendTo="body" [disabled]="!isNew" (onChange)="onOrganizationSelected($event)"/>
    </div>

    <p-tabs [(value)]="tabId">
      <p-tablist>
        <p-tab [value]="0">Generale</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel [value]="0">
          <div class="grid grid-cols-3 items-center gap-3">
            <label for="description" class="col-start-1 self-start text-left font-semibold">Descrizione</label>
            <textarea id="description" class="col-span-2 self-start" rows="5" cols="30" pTextarea [(ngModel)]="selectedItem.description"></textarea>

            <hr class="col-span-3 col-start-1" />

            <div class="border-round shadow-1 col-span-3 flex items-center justify-between p-3">
              <div class="flex items-center gap-3">
                <p-toggleswitch [(ngModel)]="selectedItem.isActive"></p-toggleswitch>
                <span [ngClass]="{ 'text-green-600 font-semibold': selectedItem.isActive, 'text-red-500 font-semibold': !selectedItem.isActive}">
                  {{ selectedItem.isActive ? 'Attivato' : 'Disattivato' }}
                </span>
              </div>
              <i class="far"
                [ngClass]="selectedItem.isActive ? 'fa-circle-check text-green-500' : 'fa-circle-xmark text-red-400'"
              style="font-size: 1.4rem;"></i>
            </div>
          </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>

    <ng-template pTemplate="footer">
      <p-button label="Chiudi"
        severity="secondary"
        variant="outlined"
        (click)="onCloseDialog()" />
        <p-button label="Salva"
          (click)="onSave()"
          [disabled]="selectedOrganization.id==0" />
        </ng-template>
      </p-dialog>
